module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c3",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c2"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c2"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c2"
  }, [_vm._v("“The heavens roared as with thunder and from the\nearth came the sound of moans. Storm clouds blackened the heavens\nand the world was shrouded in the stillness of death. Lightning\ncracked across the skies and flames flared up from the ground. From\nthe bloated clouds there came rain, and the rain washed all life\nbefore it. When the flashes in the sky had died and the flames had\nwithered all that remained was as ash.”")]), _vm._v(" "), _c('p', {
    staticClass: "c2"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre3"
  }, [_vm._v("Epic of Gilgamesh")])]), _vm._v(" "), _c('p', {
    staticClass: "c2"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c2"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4634bfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_585a07e3e5e55219dccf95a383be276f_OzNgdZ.ch.fixed.fc.tidied.stylehacked.xfixed_split_001.vue
// module id = 60
// module chunks = 0